import React from "react";
import { Download, MessageCircle } from "lucide-react";
import { CONTACT } from "../data";

const FloatingButtons = ({ onDownloadPdf, downloading }) => {
  return (
    <div className="no-print fixed bottom-6 right-6 z-40 flex flex-col gap-3" data-testid="floating-buttons">
      <button
        onClick={onDownloadPdf}
        disabled={downloading}
        className="w-14 h-14 flex items-center justify-center shadow-2xl transition-transform hover:scale-105 disabled:opacity-60"
        style={{ background: "var(--ocean-accent)", color: "#04111E" }}
        aria-label="Baixar PDF"
        data-testid="fab-download-pdf"
        title="Baixar PDF de vendas"
      >
        <Download size={22} />
      </button>
      <a
        href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Olá! Tenho interesse nas expedições Abrolhos 2026/2027.")}`}
        target="_blank"
        rel="noreferrer"
        className="w-14 h-14 flex items-center justify-center shadow-2xl transition-transform hover:scale-105"
        style={{ background: "#25D366", color: "#fff" }}
        aria-label="WhatsApp"
        data-testid="fab-whatsapp"
        title="Falar no WhatsApp"
      >
        <MessageCircle size={22} />
      </a>
    </div>
  );
};

export default FloatingButtons;